/* eslint-disable no-useless-escape */
import { useState } from "react";
import "./CSVFileUpload.css";

import { pentaCsvUpload } from "../Services/Service";

function CSVfileUpload() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [result, setResult] = useState("");
  const [badArray, setBadArray] = useState([]);
  const [badResult, setBadResult] = useState("");
  const [bData, setBData] = useState();
  const [isFileSelected, setIsFileSelected] = useState(true);
  const [isEmptyFile, setIsEmptyFile] = useState(false);
  const [spicegold, setSpicegold] = useState(null);
  const [rdata, setRData] = useState(null);
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  function transformArray(inputArray) {
    console.log(inputArray, "input");
    const transformedArray = [];

    for (const row of inputArray) {
      if (row.length === 5) {
        const [phoneNumber, emailId, fname, lname, eventId] = row;
        transformedArray.push({
          phoneNumber,
          emailId,
          fname,
          lname,
          eventId,
        });
      }
    }

    return transformedArray;
  }

  function transformData(inputData) {
    return inputData.map((item) => {
      const phoneNumber = item[0];
      const emailId = item[1];
      const fname = item[2];
      const lname = item[3];
      const eventId = item[4];
      return {
        phoneNumber,
        emailId,
        fname,
        lname,
        eventId,
      };
    });
  }
  const handleReuest = (query) => {
    console.log(query?.inValidRowsData, "----------------");
    if (query?.data?.totalSpiceGold) {
      setSpicegold(query?.data?.totalSpiceGold);
    }
    if (query?.inValidEventId) {
      const transformeddata = transformArray(query?.inValidEventId);
      setBadResult(transformeddata);
    }
    if (query?.inValidRowsData) {
      const result = transformData(query?.inValidRowsData);

      const newArray = [...badResult, ...result];

      setBadResult(newArray);
    }
  };
  const sendToNode = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const data = await pentaCsvUpload(formData);
    // const data = await pentaCsvUpload(result);
    handleReuest(data.data);
    return data;
  };

  const handleDownload = () => {
    const resumeUrl = "SampleFile.csv";

    // Create a hidden anchor element to trigger the download
    const a = document.createElement("a");
    a.href = resumeUrl;
    a.download = "SampleFile.csv";

    // Programmatically click the anchor to trigger the download
    a.click();
  };
  const uploadToBackend = async () => {
    const request = { data: result };
    const formData = new FormData();
    formData.append("csvFile", selectedFile);
    // const data = await pentaCsvUpload(JSON.stringify({ data: result }));
    const data = await pentaCsvUpload(formData);
    // const data = await pentaCsvUpload(result);
    return data;
  };
  const handleUpload = async () => {
    if (selectedFile) {
      setIsFileSelected(true);
      const formData = new FormData();
      formData.append("csvFile", selectedFile);
      // const r = await uploadToBackend(result);
      const r = await sendToNode(selectedFile);
      setBData(r.data);

      console.log(r.data, "type of result");
    } else {
      setIsFileSelected(false);
    }
  };

  console.log("Bad Result ", badResult);
  return (
    <>
      <div
        className="file-upload container center my-3"
        style={{ textAlignL: "center" }}
      >
        <div className="row text-center">
          <div
            className="col-12"
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <img
              src="/assets/images/Penta-Vertical-Logo.png"
              className="img-fluid"
              style={{ maxWidth: "90px" }}
              alt="Penta Logo"
            />
          </div>
        </div>

        {spicegold ? <p>SpiceGold updated : {spicegold}</p> : ""}

        <button className="uploadBtn mt-5" onClick={handleDownload}>
          Sample CSV File
        </button>

        <div className="row pt-2 text-center mt-3">
          <div className="col-md-6">
            <input
              type="file"
              className="col-lg-5"
              onChange={handleFileChange}
            />
          </div>

          <div className="col-md-6">
            <button className="col-lg-5 uploadBtn" onClick={handleUpload}>
              Upload
            </button>
          </div>
        </div>

        {/* { isEmptyFile && (
          <span className="error center"> Selected file is Empty !!</span>)
       
        }  */}
        {!isFileSelected && (
          <span className="error center"> No File Selected !! </span>
        )}

        {/* {badArray.length !== 0 ? (
        <div>
        <div className="table-container text-white mt-3">
        <table className="table">
          <thead>
            <tr>
              <th>Phone Number</th>
              <th>Email</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Event ID</th>
              <th>Messages</th>
            </tr>
          </thead>
          {bData.inValidRowsData.map((eventData, index) => (
            <tr key={index}>
              <td>{eventData[0]}</td>
              <td>{eventData[1]}</td>
              <td>{eventData[2]}</td>
              <td>{eventData[3]}</td>
              <td>{eventData[4]}</td>
              <td>{eventData.messages}</td>
            </tr>
          ))}
          {bData.inValidEventId.map((eventData, index) => (
            <tr key={index}>
              <td>{eventData[0]}</td>
              <td>{eventData[1]}</td>
              <td>{eventData[2]}</td>
              <td>{eventData[3]}</td>
              <td>{eventData[4]}</td>
              <td>{eventData.messages}</td>
            </tr>
          ))}

          <tbody>

          

           
          </tbody>
        </table>
        {badArray.length > 10 ? <span> Download to check all bad data</span> : ''}
      </div>
          </div>
        ) : (
          ""
        )} */}

        {/* {badResult.length ? (
          <button className="uploadBtn mt-3" onClick={downloadBadDataCSV}>
            Download Bad Data
          </button>
        ) : (
          ""
        )} */}

        {badResult?.length ? (
          <div className="table-container text-white ">
            <table className="table">
              <thead>
                <tr>
                  <th>Phone Number</th>
                  <th>Email</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Event ID</th>
                  <th>Messages</th>
                </tr>
              </thead>
              {bData?.inValidRowsData?.map((eventData, index) => (
                <tr key={index}>
                  <td>{eventData[0]}</td>
                  <td>{eventData[1]}</td>
                  <td>{eventData[2]}</td>
                  <td>{eventData[3]}</td>
                  <td>{eventData[4]}</td>
                  <td>{eventData.messages}</td>
                </tr>
              ))}
              {bData?.inValidEventId?.map((eventData, index) => (
                <tr key={index}>
                  <td>{eventData[0]}</td>
                  <td>{eventData[1]}</td>
                  <td>{eventData[2]}</td>
                  <td>{eventData[3]}</td>
                  <td>{eventData[4]}</td>
                  <td>{eventData.messages}</td>
                </tr>
              ))}

              <tbody></tbody>
            </table>
            {badResult.length > 10 ? (
              <span> Download to check all bad data</span>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default CSVfileUpload;
